import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import { SidebarProvider } from './context/SidebarContext';
import { MasterDataContextProvider } from './context/MasterDataContext';
import { NotificationProvider } from './context/NotificationContext';
import Dashboard from './pages/Dashboard';
import Pembelian from './pages/Kasir/Pembelian';
import Penjualan from './pages/Kasir/Penjualan';
import ListItemAdmin from './pages/ListItemAdmin';
import ListItemAdminV2 from './pages/ListItemAdminV2';
import ListBrankas from './pages/ListBrankas';
import ListEtalase from './pages/ListEtalase';
import ListUsers from './pages/ListUsers';
import Login from './pages/Login';
import SuccessLogin from './pages/SuccessLogin';
import ProtectedRoute from './utils/ProtectedRoute';
import RefundProtectedRoute from './utils/RefundProtectedRoute';
import { ToastContainer } from 'react-toastify';
import ListPembelian from './pages/ListPembelian';
import BarangOpname from './pages/BarangOpname/BarangOpname';
import TrxPenjualan from './pages/Transaksi/TrxPenjualan';
import TrxPenjualanV2 from './pages/Transaksi/TrxPenjualanV2';
import TrxPembelian from './pages/Transaksi/TrxPembelian';
import TrxPembelianV2 from './pages/Transaksi/TrxPembelianV2';
import SaldoKAS from './pages/SaldoKAS';
import Summary from './pages/Summary';
import PengembalianBarang from './pages/Kasir/PengembalianBarang';
import HistorySaldoKasir from './pages/Kasir/HistorySaldoKasir';
import TambahBarang from './pages/operator/TambahBarang';
import BarangRusak from './pages/BarangRusak';
import LaporanKaratItem from './pages/LaporanKaratItem';
import Pengeluaran from './pages/Pengeluaran';
import TransaksiLuar from './pages/TransaksiLuar';
import LaporanCashflow from './pages/LaporanCashflow';
import TransaksiTertunda from './pages/transaksiTertunda/transaksiTertunda';
import TransferBarang from './pages/TransferBarang/transferBarang';
import ListTransaksiTertunda from './pages/transaksiTertunda/ListTransaksiTertunda';
import HistoriTransferMasuk from './pages/HistoryTransfer/HistoriTransferMasuk';
import HistoriTransferKeluar from './pages/HistoryTransfer/HistoriTransferKeluar';
import EtalaseKeluar from './pages/HistoryTransfer/EtalaseKeluar';
import Riwayat from './pages/riwayat';
import BarangTerhapus from './pages/BarangTerhapus';
import PageNotFound from './pages/PageNotFound';
import GaleriBarang from './pages/galeri/GaleriBarang';
import GaleriPenjualan from './pages/galeri/GaleriPenjualan';
import GaleriPembelian from './pages/galeri/GaleriPembelian';
import LabaPenjualan from './pages/LabaPenjualan';
import DashboardKeuangan from './pages/DashboardKeuangan';
import OperasiBarang from './pages/OperasiBarang';
import GoldValuation from './pages/Analitik/GoldValuation';
import ScanKwitansi from './pages/ScanKwitansi';
// import ManajemenCabang from './pages/Owner/ManajemenCabang';
// import ManajemenUser from './pages/Owner/ManajemenUser';
// import RiwayatStokHarian from './pages/Analitik/RiwayatStokHarian';

import BarangTerhapusV2 from './pages/BarangTerhapusV2';
import HistoriHapusBrankas from './pages/Brankas/HistoriHapusBrankas';
import CreateSuratJalan from './pages/Pengiriman/CreateSuratJalan';
import HistoriMasukKeluar from './pages/HistoryTransfer/HistoriMasukKeluar';
import HistoriPenghapusan from './pages/Barang/HistoriPenghapusan';
import VerifikasiHapusEtalaseV2 from './pages/Barang/VerifikasiHapusEtalaseV2';
import HistoriPengiriman from './pages/Pengiriman/HistoriPengiriman';
import HistoriPermohonanBrankas from './pages/Brankas/HistoriPermohonanBrankas';
import KaryawanList from './pages/ManajemenUser/Karyawan/KaryawanList';
import LaporanKeluarMasukOperator from './pages/Brankas/LaporanKeluarMasukOperator';
import LaporanPembayaran from './pages/Transaksi/LaporanPembayaran';
import PengaturanSistem from './pages/PengaturanSistem';
import PermohonanPindahBrankas from './pages/Brankas/PermohonanPindahBrankas';
import VerifikasiHapusPembelian from './pages/Brankas/VerifikasiHapusPembelian';
import VerifikasiPermohonanBrankas from './pages/Brankas/VerifikasiPermohonanBrankas';
import VerifikasiPermohonanBrankasV2 from './pages/Brankas/VerifikasiPermohonanBrankasV2';
import VerifikasiTransferToko from './pages/Barang/VerifikasiTransferToko';
import VerifikasiTransferTokoV2 from './pages/Barang/VerifikasiTransferTokoV2';


const routes = [
  { path: '/login', element: <Login /> },
  { path: '/success', element: <SuccessLogin />, protected: true },
  { path: '/pengeluaran', element: <Pengeluaran />, protected: true },
  { path: '/barang-terhapus', element: <BarangTerhapus />, protected: true },
  { path: '/laporan-cashflow', element: <LaporanCashflow />, protected: true },
  { path: '/riwayat', element: <Riwayat />, protected: true },
  { path: '/trx-luar', element: <TransaksiLuar />, protected: true },
  { path: '/galeri-barang', element: <GaleriBarang />, protected: true },
  { path: '/galeri-penjualan', element: <GaleriPenjualan />, protected: true },
  { path: '/galeri-pembelian', element: <GaleriPembelian />, protected: true },
  { path: '/tambah-barang', element: <TambahBarang />, protected: true },
  { path: '/transfer-barang', element: <TransferBarang />, protected: true },
  { path: '/list-transaksi-tertunda', element: <ListTransaksiTertunda />, protected: true },
  { path: '/laporan-karat-item', element: <LaporanKaratItem />, protected: true },
  { path: '/transaksi-tertunda', element: <TransaksiTertunda />, protected: true },
  { path: '/', element: <Dashboard />, protected: true },
  { path: '/history-saldo-kasir', element: <HistorySaldoKasir />, protected: true },
  { path: '/list-items-admin', element: <ListItemAdmin />, protected: true },
  { path: '/list-items-admin-v2', element: <ListItemAdminV2 />, protected: true },
  { path: '/list-barang-v2', element: <ListItemAdminV2 />, protected: true },
  { path: '/list-brankas', element: <ListBrankas />, protected: true },
  { path: '/list-etalase', element: <ListEtalase />, protected: true },
  { path: '/histori-transfer-masuk', element: <HistoriTransferMasuk />, protected: true },
  { path: '/histori-transfer-keluar', element: <HistoriTransferKeluar />, protected: true },
  { path: '/etalase-keluar', element: <EtalaseKeluar />, protected: true },
  { path: '/list-users', element: <ListUsers />, protected: true },
  { path: '/penjualan', element: <Penjualan />, protected: true },
  {
    path: '/pengembalian',
    element: (
      <RefundProtectedRoute>
        <PengembalianBarang />
      </RefundProtectedRoute>
    ),
    protected: true,
  },
  { path: '/pembelian', element: <Pembelian />, protected: true },
  { path: '/data-pembelian', element: <ListPembelian />, protected: true },
  { path: '/barang-opname', element: <BarangOpname />, protected: true },
  { path: '/transaksi-penjualan', element: <TrxPenjualan />, protected: true },
  { path: '/transaksi-penjualan-v2', element: <TrxPenjualanV2 />, protected: true },
  { path: '/transaksi-pembelian', element: <TrxPembelian />, protected: true },
  { path: '/transaksi-pembelian-v2', element: <TrxPembelianV2 />, protected: true },
  { path: '/saldo-kas', element: <SaldoKAS />, protected: true },
  { path: '/summary', element: <Summary />, protected: true },
  { path: '/barang-rusak', element: <BarangRusak />, protected: true },
  { path: '/laba-penjualan', element: <LabaPenjualan />, protected: true },
  { path: '/dashboard-keuangan', element: <DashboardKeuangan />, protected: true },
  { path: '/operasi-barang', element: <OperasiBarang />, protected: true },
  // { path: '/owner/cabang', element: <ManajemenCabang />, protected: true },
  // { path: '/owner/users', element: <ManajemenUser />, protected: true },
  { path: '/scan-kwitansi', element: <ScanKwitansi />, protected: true },
  { path: '/analitik-emas', element: <GoldValuation />, protected: true },
  // { path: '/riwayat-stok-harian', element: <RiwayatStokHarian />, protected: true },
  
  { path: '/barang-terhapus-v2', element: <BarangTerhapusV2 />, protected: true },
  { path: '/brankas/histori-hapus', element: <HistoriHapusBrankas />, protected: true },
  { path: '/buat-surat-jalan', element: <CreateSuratJalan />, protected: true },
  { path: '/histori-masuk-keluar', element: <HistoriMasukKeluar />, protected: true },
  { path: '/histori-penghapusan', element: <HistoriPenghapusan isVerifikasi={false} />, protected: true },
  { path: '/histori-pengiriman', element: <HistoriPengiriman />, protected: true },
  { path: '/histori-permohonan-brankas', element: <HistoriPermohonanBrankas />, protected: true },
  { path: '/karyawan', element: <KaryawanList />, protected: true },
  { path: '/laporan-keluar-masuk-operator', element: <LaporanKeluarMasukOperator />, protected: true },
  { path: '/laporan-pembayaran', element: <LaporanPembayaran />, protected: true },
  { path: '/pengaturan', element: <PengaturanSistem />, protected: true },
  { path: '/permohonan-pindah-brankas', element: <PermohonanPindahBrankas />, protected: true },
  { path: '/verifikasi-hapus-etalase', element: <HistoriPenghapusan isVerifikasi={true} />, protected: true },
  { path: '/verifikasi-hapus-etalase-v2', element: <VerifikasiHapusEtalaseV2 />, protected: true },
  { path: '/verifikasi-hapus-pembelian', element: <VerifikasiHapusPembelian />, protected: true },
  { path: '/verifikasi-permohonan-brankas', element: <VerifikasiPermohonanBrankas />, protected: true },
  { path: '/verifikasi-permohonan-brankas-v2', element: <VerifikasiPermohonanBrankasV2 />, protected: true },
  { path: '/verifikasi-transfer-toko', element: <VerifikasiTransferToko />, protected: true },
  { path: '/verifikasi-transfer-toko-v2', element: <VerifikasiTransferTokoV2 />, protected: true },
  { path: '/transfer-antar-toko', element: <VerifikasiTransferToko />, protected: true },
  { path: '/transfer-antar-toko-v2', element: <VerifikasiTransferTokoV2 />, protected: true },

  { path: '*', element: <PageNotFound /> },
];

function App() {
  return (
    <ThemeProvider>
      <SidebarProvider>
        <MasterDataContextProvider>
          <NotificationProvider>
            <Router>
              <Routes>
                {routes.map(({ path, element, protected: isProtected }) => (
                  <Route
                    key={path}
                    path={path}
                    element={isProtected ? <ProtectedRoute>{element}</ProtectedRoute> : element}
                  />
                ))}
              </Routes>
            </Router>
            <ToastContainer />
          </NotificationProvider>
        </MasterDataContextProvider>
      </SidebarProvider>
    </ThemeProvider>
  );
}

export default App;
